var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"survey"},[_c('survey',{attrs:{"survey":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }